import AbstractToggleList from './AbstractToggleList';
import PropTypes from 'prop-types';

export default class ToggleList extends AbstractToggleList {
  static propTypes = {
    ...AbstractToggleList.propTypes,
    valueToggles: PropTypes.object.isRequired
  };

  isValueSelected(value) {
    return this.props.valueToggles[value] === true;
  }
}
